import { render, staticRenderFns } from "./navigation_page.vue?vue&type=template&id=633fac24&scoped=true"
import script from "./navigation_page.vue?vue&type=script&lang=js"
export * from "./navigation_page.vue?vue&type=script&lang=js"
import style0 from "./navigation_page.vue?vue&type=style&index=0&id=633fac24&lang=css"
import style1 from "./navigation_page.vue?vue&type=style&index=1&id=633fac24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633fac24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('633fac24')) {
      api.createRecord('633fac24', component.options)
    } else {
      api.reload('633fac24', component.options)
    }
    module.hot.accept("./navigation_page.vue?vue&type=template&id=633fac24&scoped=true", function () {
      api.rerender('633fac24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/website/navigation_article/navigation_page.vue"
export default component.exports